import React, {useState, useEffect} from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import { connect } from 'react-redux';
import ServicioService from '@app/services/servicios.service';

const Styles = styled.div``;

const SelectServicios = ({
    id,
    value,
    onChange,
    isInvalid,
    isClearable,
    disabled,
    stack,
    ...defaultProps
}) => {
    const [items, setItems] = useState([]);
    const [options, setOptions] = useState([]);
    const [selectedValue, setSelectedValue] = useState();

    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        if(Array.isArray(ev)){
            onChange(ev.map(e=>{
                const item = items.find(it=>it.id_s === e.value);
                return {
                    ...e,
                    item: item,
                }
            }));
        } else if(ev){
            ev.item = items.find(it=>it.id_s === ev.value);
            onChange(ev);
        } else {
            onChange(null);
        }
    };
    useEffect(() => {
        ServicioService.getAll().then((response) => {
            setItems(response);
        });
    }, []);
    useEffect(() => {
        const newOptions = items
            .map((item) => {
            return {
                value: item.id_s,
                label: item.nombre_s,
                importe: item.importe_s,
                anchoBajada: item.anchoBajada_s,
                anchoSubida: item.anchoSubida_s,
                tipoAnchoBajada: item.tipoAnchoBajada_s,
                tipoAnchoSubida: item.tipoAnchoSubida_s,
                moneda: item.moneda_s,
            };
        });
        setOptions(newOptions);
        if(Array.isArray(value)){
            setSelectedValue(value.map(va=>{
                const item = items.find(it=>it.id_s === va);
                if(item){
                    return {
                        label:item.nombre_s,
                        value:item.id_s,
                    };  
                }
                return {
                    label:va.nombre_s,
                    value:va.id_s,
                };
                
            }))
        }
    }, [items]);

    const conditionalProps = {}
    if(stack && stack.length === 0){
        conditionalProps.menuPortalTarget = document.body;
    }
    return (
        <Styles>
            <Select
                {...defaultProps}
                isDisabled={disabled}
                inputId={id}
                name={id}
                className={`react-select-container ${
                    isInvalid ? 'is-invalid' : ''
                }`}
                noOptionsMessage={()=>"Sin opciones"}
                classNamePrefix="react-select"
                placeholder="Seleccione..."
                options={options}
                value={selectedValue}
                onChange={onSelectValue}
                isClearable={isClearable}
            />
        </Styles>
    );
};

SelectServicios.defaultProps = {
    isClearable: false,
    onChange: () => {},
};

const mapStateToProps = (state) => ({
    stack: state.modalProvider.stack,
})

const mapDispatchToProps = {}
export default connect(mapStateToProps, mapDispatchToProps)(SelectServicios)

